import { gql } from "graphql-request"
import { ServiceGraphql } from "./Graphql"

export const graphSetPin = async (contractId, newPin, otp) => {
  const SET_PIN = gql`
  mutation SetPIN($contractId: Int!, $newPin: String!) {
    SetPIN(contractId: $contractId, newPIN: $newPin) {
      data
      status
    }
  }
  `

  const variables = {
    "contractId": parseInt(contractId),
    "newPin": newPin
  }

  const headers = {
    'Content-Type': 'application/json',
    'x-verify-code': otp,
  }

  const response = await ServiceGraphql.request(SET_PIN, variables, headers);
  return response.SetPIN;
}

export const graphChangePin = async (contractId, newPin, oldPin, otp) => {
  const CHANGE_PIN = gql`
  mutation ChangePIN($contractId: Int!, $oldPin: String!, $newPin: String!) {
    ChangePIN(contractId: $contractId, oldPIN: $oldPin, newPIN: $newPin) {
      data
      status
    }
  }
  `

  const variables = {
    "contractId": parseInt(contractId),
    "oldPin": oldPin,
    "newPin": newPin
  }

  const headers = {
    'Content-Type': 'application/json',
    'x-verify-code': otp,
  }
  const response = await ServiceGraphql.request(CHANGE_PIN, variables, headers);
  return response.ChangePIN;
}


export const setContractStatus = async (data, otp) => {
  const LOCK_CARD = gql`
  mutation SetContractStatus($contractId: Int!, $newStatus: Way4ContractStatus!) {
    SetContractStatus(contractId: $contractId, newStatus: $newStatus) {
      data
      status
    }
  }
  `
  const headers = {
    'Content-Type': 'application/json',
    'x-verify-code': otp,
  }
  const response = await ServiceGraphql.request(LOCK_CARD, data, headers);
  return response.SetContractStatus;
}

export const switchEcommerceStatusOTP = async (data, otp) => {
  const ECOM = gql`
  mutation SwitchEcommerceStatus($contractId: Int!, $ecomStatus: Way4EcommerceStatus!) {
    SwitchEcommerceStatus(contractId: $contractId, ecomStatus: $ecomStatus) {
      data
      status
    }
  }
  `
  const headers = {
    'Content-Type': 'application/json',
    'x-verify-code': otp,
  }
  const response = await ServiceGraphql.request(ECOM, data, headers);
  return response.SwitchEcommerceStatus;
}


export const retrieveCVV2OTP = async (data, otp) => {
  const CVV2 = gql`
  query RetrieveCVV2($contractId: Int!) {
    RetrieveCVV2(contractId: $contractId) {
      data
      status
    }
  }
  `
  const headers = {
    'Content-Type': 'application/json',
    'x-verify-code': otp,
  }

  const response = await ServiceGraphql.request(CVV2, data, headers);
  return response.RetrieveCVV2;
}


export const upgradePlasticCard = async (data, otp) => {
  const UPGRADE_CARD = gql`
  mutation UpgradePlasticCard($contractId: Int!) {
    UpgradePlasticCard(contractId: $contractId) {
      data
      status
    }
  }
  `
  const headers = {
    'Content-Type': 'application/json',
    'x-verify-code': otp,
  }
  const response = await ServiceGraphql.request(UPGRADE_CARD, data,headers);
  return response.UpgradePlasticCard;
}


export const graphActivateCard = async (data, otp) => {
  const ACTIVE_CARD = gql`
  mutation ActivateCard($contractId: Int!) {
    ActivateCard(contractId: $contractId) {
      data
      status
    }
  }
  `  
  const headers = {
    'Content-Type': 'application/json',
    'x-verify-code': otp

  }
  const response = await ServiceGraphql.request(ACTIVE_CARD, data, headers);
  return response.ActivateCard;
}


export const graphGetUsageLimiter = async (contractId) => {
  const GET_USAGE_LIMITER = gql`
  query GetUsageLimitter($contractId: Int!) {
    GetUsageLimitter(contractId: $contractId) {
      data
      status
    }
  }
 `

  const variables = {
    "contractId": parseInt(contractId)
  }

  const response = await ServiceGraphql.request(GET_USAGE_LIMITER, variables);
  return response.GetUsageLimitter;
}

export const graphSetUsageLimiter = async (variables, otp) => {
  const UPDATE_USAGE_LIMITER = gql`
  mutation SetUsageLimitter($contractId: Int!, $maxAmount: Int!, $maxNumber: Int!, $maxSingleAmount: Int!) {
    SetUsageLimitter(contractId: $contractId, maxAmount: $maxAmount, maxNumber: $maxNumber, maxSingleAmount: $maxSingleAmount) {
      data
      status
    }
  }
  `

  const headers = {
    'Content-Type': 'application/json',
    'x-verify-code': otp,
  }

  const response = await ServiceGraphql.request(UPDATE_USAGE_LIMITER, variables, headers);
  return response.SetUsageLimitter
}